import * as React from 'react';
const DiarreaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M114.03 109.25c5.33 1.95 13.05 1.43 21.82 0V73.12c-12.86.65-17.79-1.28-31.29-4.04s-40.4-3.81-40.4 19.62"
      className="prefix__cls-2"
    />
    <ellipse
      cx={86.75}
      cy={88.7}
      className="prefix__cls-2"
      rx={10.13}
      ry={4.68}
    />
    <ellipse
      cx={86.75}
      cy={88.7}
      className="prefix__cls-1"
      rx={22.6}
      ry={12.47}
    />
    <path
      d="M64.16 88.7v31.17c0 6.89 10.12 12.47 22.6 12.47s22.6-5.58 22.6-12.47V88.7"
      className="prefix__cls-1"
    />
  </svg>
);
export default DiarreaIcon;
